var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile" },
    [
      _c("div", { staticClass: "tile is-parent is-vertical" }, [
        _c(
          "article",
          {
            staticClass: "tile is-child box",
            staticStyle: { "max-height": "250px" },
          },
          [
            _c("p", { staticClass: "title" }, [_vm._v("Summary")]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Batch No")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Batch No.",
                          precision: 0,
                        },
                        model: {
                          value: _vm.innerValue.batchNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "batchNo", $$v)
                          },
                          expression: "innerValue.batchNo",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Batch Date")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Batch Date",
                                              readonly: "",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.batchDate,
                          callback: function ($$v) {
                            _vm.batchDate = $$v
                          },
                          expression: "batchDate",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Min. Batch Size"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          placeholder: "Min. Batch Size",
                          precision: 0,
                        },
                        model: {
                          value: _vm.innerValue.minBatchSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "minBatchSize", $$v)
                          },
                          expression: "innerValue.minBatchSize",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Batch Status"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.batchStatus,
                              expression: "innerValue.batchStatus",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "batchStatus",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(
                          _vm.ormBatchStatusType,
                          function (status, propertyName) {
                            return _c(
                              "option",
                              { key: status, domProps: { value: status } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatOrmBatchStatus(
                                        propertyName
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Agreed ARC")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.agreedArc,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "agreedArc", $$v)
                          },
                          expression: "innerValue.agreedArc",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ALR Lower Threshold"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.alrLowerThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "alrLowerThreshold", $$v)
                          },
                          expression: "innerValue.alrLowerThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("ALR Upper Threshold"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          min: 0,
                          symbol: "$",
                          placeholder: "Agreed ARC",
                          precision: 2,
                        },
                        model: {
                          value: _vm.innerValue.alrUpperThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "alrUpperThreshold", $$v)
                          },
                          expression: "innerValue.alrUpperThreshold",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _vm.entities
              ? _c("orm-batch-statistics", {
                  attrs: {
                    count: _vm.entities ? _vm.entities.length : 0,
                    alr: _vm.alr,
                    "alr-lower-threshold": _vm.innerValue.alrLowerThreshold,
                    "alr-upper-threshold": _vm.innerValue.alrUpperThreshold,
                    "average-labour-units": _vm.averageLabourUnits,
                    "average-labour-values": _vm.averageLabourValues,
                    "average-non-labour-values": _vm.averageNonLabourValues,
                    "average-total-ex-gst": _vm.averageTotalExGst,
                    "adjusted-total": _vm.adjustedTotal,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _vm._m(0),
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.batchQuoteColumns,
                  "page-index": _vm.filter.pageIndex,
                  "page-size": _vm.filter.pageSize,
                  "total-rows": _vm.totalRows,
                  "is-loading": _vm.isTableLoading,
                  "sort-column": _vm.filter.sortColumn,
                  "sort-order": _vm.filter.sortOrder,
                  draggable: true,
                  "draggable-empty": true,
                  "show-pagination": false,
                },
                on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
              },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        list: _vm.entities,
                        group: "quote",
                        tag: "tbody",
                      },
                      on: { change: _vm.itemMoved, end: _vm.endMove },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                      animation: _vm.animationDuration,
                    },
                    false
                  ),
                  _vm._l(_vm.entities, function (quote, index) {
                    return _c(
                      "tr",
                      {
                        key: quote.quoteId,
                        class: { "is-new-item": quote.isNew },
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewQuote(quote.quoteId)
                                },
                              },
                            },
                            [_vm._v(_vm._s(quote.quoteNo))]
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAddQuoteActive,
                                expression: "!isAddQuoteActive",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(quote.claimNo))]
                        ),
                        _c("td", [_vm._v(_vm._s(quote.rego))]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAddQuoteActive,
                                expression: "!isAddQuoteActive",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(quote.customerName))]
                        ),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAddQuoteActive,
                                expression: "!isAddQuoteActive",
                              },
                            ],
                            staticClass: "has-text-right",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  quote.excess,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.labourHour,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.rate,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.labourTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.partTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.subletTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.miscTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                quote.totalExGst,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isInvoiceColumnVisible,
                                expression: "isInvoiceColumnVisible",
                              },
                            ],
                            staticClass: "has-text-centered",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "icon",
                                class: [
                                  quote.invoiced
                                    ? "has-text-success"
                                    : "has-text-danger",
                                ],
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-24px",
                                  class: [quote.invoiced ? "mdi-check" : ""],
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAddQuoteActive,
                                expression: "!isAddQuoteActive",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.camelCaseToDescription(
                                  _vm.getPropertyNameByValue(
                                    _vm.ormQuoteStatusTypes,
                                    quote.quoteStatusId
                                  )
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isAddQuoteActive,
                                expression: "!isAddQuoteActive",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(quote.qdeStatus))]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "has-text-right",
                            class: {
                              "has-text-danger": _vm.delta(quote) < 0,
                              "has-text-success": _vm.delta(quote) >= 0,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.delta(quote),
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass:
                              "has-vertical-middle has-text-centered is-content-width",
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: quote.excess > quote.totalExGst,
                                    expression:
                                      "quote.excess > quote.totalExGst",
                                  },
                                ],
                                staticClass:
                                  "icon has-text-danger tooltip is-tooltip-danger is-tooltip-topright",
                                attrs: {
                                  "data-tooltip": "Excess exceeds Total",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert mdi-24px",
                                }),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isAddQuoteActive,
                                    expression: "isAddQuoteActive",
                                  },
                                ],
                                staticClass:
                                  "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                                attrs: { "data-tooltip": "Remove from batch" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFromBatch(index, quote)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-medium" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-minus mdi-24px",
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "template",
                  { slot: "empty" },
                  [
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          attrs: {
                            list: _vm.entities,
                            group: "quote",
                            tag: "tbody",
                          },
                          on: { change: _vm.itemMoved, end: _vm.endMove },
                        },
                        "draggable",
                        {
                          disabled: !_vm.isRowDraggable,
                          chosen: "chosen",
                          ghostClass: "draggable-ghost",
                          dragClass: "draggable-drag",
                          animation: _vm.animationDuration,
                        },
                        false
                      ),
                      [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              attrs: { colspan: _vm.batchQuoteColumns.length },
                            },
                            [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content has-text-grey has-text-centered",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { icon: "icon is-large" } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-48px mdi-emoticon-sad",
                                        }),
                                      ]
                                    ),
                                    _c("p", [_vm._v("Nothing")]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated slideInRight",
            "leave-active-class": "animated slideOutRight",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAddQuoteActive,
                  expression: "isAddQuoteActive",
                },
              ],
              staticClass: "tile is-parent",
            },
            [
              _c("article", { staticClass: "tile is-child box" }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Available Quotes"),
                    ]),
                    _c("div", { staticClass: "field-body" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Search"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.availableQuoteQuery,
                                expression: "availableQuoteQuery",
                              },
                            ],
                            staticClass: "input",
                            attrs: {
                              type: "text",
                              placeholder: "Start typing to search",
                            },
                            domProps: { value: _vm.availableQuoteQuery },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.availableQuoteQuery = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Total Lower Limit"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                min: null,
                                placeholder: "Total Lower Limit",
                                precision: 0,
                              },
                              model: {
                                value: _vm.totalLowerLimit,
                                callback: function ($$v) {
                                  _vm.totalLowerLimit = $$v
                                },
                                expression: "totalLowerLimit",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Total Upper Limit"),
                          ]),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              placeholder: "Total Upper Limit",
                              precision: 0,
                            },
                            model: {
                              value: _vm.totalUpperLimit,
                              callback: function ($$v) {
                                _vm.totalUpperLimit = $$v
                              },
                              expression: "totalUpperLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "column is-narrow" }, [
                    _c("div", { staticClass: "field-body" }, [
                      _c("div", { staticClass: "field-label is-normal" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Source"),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedAvailableBatchId,
                                    expression: "selectedAvailableBatchId",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedAvailableBatchId = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  { domProps: { value: _vm.guid.empty() } },
                                  [_vm._v("Not Batched")]
                                ),
                                _vm._l(
                                  _vm.activeBatchIds,
                                  function (activeBatchId) {
                                    return _c(
                                      "option",
                                      {
                                        key: activeBatchId.value,
                                        domProps: { value: activeBatchId.key },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              `Batch No. ${activeBatchId.value}`
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control is-pulled-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.closeAvailableQuotes()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", { staticClass: "mdi mdi-close" }),
                              ]),
                              _c("span", [_vm._v("Close")]),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm.selectedAvailableBatchId !== _vm.guid.empty()
                  ? _c("div", { staticClass: "is-divider" })
                  : _vm._e(),
                _vm.selectedAvailableBatchId !== _vm.guid.empty() &&
                _vm.availableBatch
                  ? _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _vm.availableQuotes
                          ? _c("orm-batch-statistics", {
                              attrs: {
                                count: _vm.availableQuotes
                                  ? _vm.availableQuotes.length
                                  : 0,
                                alr: _vm.availableAlr,
                                "alr-lower-threshold":
                                  _vm.availableBatch.alrLowerThreshold,
                                "alr-upper-threshold":
                                  _vm.availableBatch.alrUpperThreshold,
                                "average-labour-units":
                                  _vm.availableAverageLabourUnits,
                                "average-labour-values":
                                  _vm.availableAverageLabourValues,
                                "average-non-labour-values":
                                  _vm.availableAverageNonLabourValues,
                                "average-total-ex-gst":
                                  _vm.availableAverageTotalExGst,
                                "adjusted-total": _vm.availableAdjustedTotal,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "is-divider" }),
                _c(
                  "div",
                  {
                    staticClass: "field",
                    staticStyle: { "max-width": "45vw", overflow: "auto" },
                  },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.availableQuoteColumns,
                          "page-index": _vm.availableQuoteFilter.pageIndex,
                          "page-size": _vm.availableQuoteFilter.pageSize,
                          "total-rows": _vm.availableQuoteTotalRows,
                          "is-loading": _vm.isAvailableQuoteTableLoading,
                          "sort-column": _vm.availableQuoteFilter.sortColumn,
                          "sort-order": _vm.availableQuoteFilter.sortOrder,
                          draggable: true,
                          "draggable-empty": true,
                          "show-pagination": false,
                        },
                        on: {
                          pageChanged: _vm.onAvailableQuotePageChange,
                          sort: _vm.onAvailableQuoteSort,
                        },
                      },
                      [
                        _c(
                          "draggable",
                          _vm._b(
                            {
                              attrs: {
                                list: _vm.availableQuotes,
                                group: "quote",
                                tag: "tbody",
                              },
                              on: {
                                change: _vm.onAvailableQuoteMoved,
                                start: _vm.onAvailableQuoteStartMove,
                                end: _vm.onAvailableQuoteEndMove,
                              },
                            },
                            "draggable",
                            {
                              disabled: !_vm.isAvailableQuoteRowDraggable,
                              chosen: "chosen",
                              ghostClass: "draggable-ghost",
                              dragClass: "draggable-drag",
                              animation: _vm.animationDuration,
                            },
                            false
                          ),
                          _vm._l(
                            _vm.filteredAvailableQuotes,
                            function (quote, index) {
                              return _c(
                                "tr",
                                {
                                  key: quote.quoteId,
                                  on: {
                                    click: function ($event) {
                                      return _vm.highlightSelectedAvailableQuote(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("td", [_vm._v(_vm._s(quote.quoteNo))]),
                                  _c("td", [_vm._v(_vm._s(quote.rego))]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.labourHour,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.rate,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.labourTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.partTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.subletTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.miscTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          quote.totalExGst,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "has-vertical-middle has-text-centered is-content-width",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button is-success is-small is-inverted tooltip is-tooltip-topright",
                                          attrs: {
                                            "data-tooltip": "Add to batch",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addToBatch(
                                                index,
                                                quote
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-plus mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _c(
                          "template",
                          { slot: "empty" },
                          [
                            _c(
                              "draggable",
                              _vm._b(
                                {
                                  attrs: {
                                    list: _vm.availableQuotes,
                                    group: "quote",
                                    tag: "tbody",
                                  },
                                  on: {
                                    change: _vm.itemMoved,
                                    end: _vm.endMove,
                                  },
                                },
                                "draggable",
                                {
                                  disabled: !_vm.isAvailableQuoteRowDraggable,
                                  chosen: "chosen",
                                  ghostClass: "draggable-ghost",
                                  dragClass: "draggable-drag",
                                  animation: _vm.animationDuration,
                                },
                                false
                              ),
                              [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        colspan:
                                          _vm.availableQuoteColumns.length,
                                      },
                                    },
                                    [
                                      _c(
                                        "section",
                                        { staticClass: "section" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "content has-text-grey has-text-centered",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    icon: "icon is-large",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "mdi mdi-48px mdi-emoticon-sad",
                                                  }),
                                                ]
                                              ),
                                              _c("p", [_vm._v("Nothing")]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Batched Quotes")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }